import * as productApi from "src/api/product";

export function useVASItems({ formData }) {
  const onAddItem = ({ item }) => {
    unref(formData).vas_items.push(item);
  };

  const { toggleItemForm } = usePurchaseOrderStore();

  const addVasItem = (props) => {
    toggleItemForm({
      open: true,
      props: {
        ...props,
        entity: { ...unref(formData), type: props.entityType },
        items: props.items,
        toggle: { method: onAddItem },
      },
    });
  };

  const populateVasItems = async () => {
    const response = await productApi.index({
      params: {
        isActive: 1,
        categoryNames: "VAS",
        is_always_applicable: 1,
      },
    });

    let vasItems = response?.data?.data?.data || [];

    if (vasItems.length) {
      unref(formData).vas_items = vasItems.map((item) => {
        const { _id, gst_rate, min_price } = item;

        item = {
          ...item,
          amount: min_price,
          amount_wt: min_price,
          category_name: "VAS",
          gst: gst_rate,
          is_tax_included: true,
          item_id: _id,
          qty: 1,
          rate: min_price,
          rate_wt: min_price,
        };

        delete item._id;

        delete item.gst_rate;

        return item;
      });
    }
  };

  const removeVasItem = (index) => {
    unref(formData).vas_items.splice(index, 1);
  };

  return {
    addVasItem,
    populateVasItems,
    removeVasItem,
  };
}
